module.exports = __webpack_public_path__ + "img/bracket.cd5962e8.svg";